import React, { useState } from 'react';
import { courses } from '../mockData';
import { Check } from 'lucide-react';

const Courses = () => {
  const [selectedLevel, setSelectedLevel] = useState('All Levels');

  const levels = ['All Levels', 'Beginners', 'Intermediate', 'Advanced'];

  return (
    <div className="bg-[#1a1c1b] min-h-screen pt-24 pb-20">
      <div className="container mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-12">
          <h1 className="text-[#d9fb06] font-black text-5xl md:text-7xl uppercase mb-4">
            Our Courses
          </h1>
          <p className="text-[#dfddd6] text-xl max-w-3xl mx-auto">
            Master the art of combat with our comprehensive training programs designed for all skill levels
          </p>
        </div>

        {/* Level Filter */}
        <div className="flex flex-wrap justify-center gap-4 mb-12">
          {levels.map((level) => (
            <button
              key={level}
              onClick={() => setSelectedLevel(level)}
              className={`px-6 py-2 rounded-full font-semibold uppercase text-sm transition-all ${
                selectedLevel === level
                  ? 'bg-[#d9fb06] text-[#1a1c1b]'
                  : 'bg-[#302f2c] text-[#888680] hover:bg-[#3f4816] hover:text-[#d9fb06]'
              }`}
            >
              {level}
            </button>
          ))}
        </div>

        {/* Courses Grid */}
        <div className="space-y-12">
          {courses.map((course, index) => (
            <div
              key={course.id}
              className={`flex flex-col ${
                index % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'
              } bg-[#302f2c] border border-[#3f4816] overflow-hidden hover:border-[#d9fb06] transition-all duration-300`}
            >
              {/* Image */}
              <div className="lg:w-1/2">
                <div className="aspect-[4/3] lg:h-full">
                  <img
                    src={course.image}
                    alt={course.title}
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>

              {/* Content */}
              <div className="lg:w-1/2 p-8 lg:p-12 flex flex-col justify-center">
                <div className="inline-block bg-[#3f4816] text-[#d9fb06] px-4 py-1 rounded-full text-xs font-bold uppercase mb-4 self-start">
                  {course.discipline}
                </div>
                <h2 className="text-[#d9fb06] font-black text-3xl md:text-4xl uppercase mb-4">
                  {course.title}
                </h2>
                <p className="text-[#dfddd6] text-lg mb-6 leading-relaxed">
                  {course.description}
                </p>

                {/* Levels */}
                <div className="mb-6">
                  <h3 className="text-[#d9fb06] font-semibold uppercase text-sm mb-2 tracking-wide">
                    Skill Levels
                  </h3>
                  <div className="flex flex-wrap gap-2">
                    {course.levels.map((level) => (
                      <span
                        key={level}
                        className="bg-[#1a1c1b] text-[#dfddd6] px-3 py-1 rounded-full text-sm"
                      >
                        {level}
                      </span>
                    ))}
                  </div>
                </div>

                {/* Age Groups */}
                <div className="mb-6">
                  <h3 className="text-[#d9fb06] font-semibold uppercase text-sm mb-2 tracking-wide">
                    Age Groups
                  </h3>
                  <p className="text-[#dfddd6]">{course.ageGroups}</p>
                </div>

                {/* Benefits */}
                <div className="mb-8">
                  <h3 className="text-[#d9fb06] font-semibold uppercase text-sm mb-3 tracking-wide">
                    What You'll Learn
                  </h3>
                  <ul className="space-y-2">
                    {course.benefits.map((benefit, i) => (
                      <li key={i} className="flex items-start">
                        <Check size={20} className="text-[#d9fb06] mr-2 flex-shrink-0 mt-1" />
                        <span className="text-[#dfddd6]">{benefit}</span>
                      </li>
                    ))}
                  </ul>
                </div>

                <a
                  href="/book"
                  className="bg-[#d9fb06] text-[#1a1c1b] px-8 py-3 rounded-full font-bold uppercase text-sm hover:opacity-90 transition-all hover:scale-105 inline-flex items-center justify-center self-start"
                >
                  Book This Course
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Courses;
